// extracted by mini-css-extract-plugin
module.exports =  {"item":"a10a3f92e9--item--jW0Mi","name":"a10a3f92e9--name--iR9rY","value":"a10a3f92e9--value--ZAuMn"};